import { z } from 'zod';
export const uuid = z.string().uuid();
export const isoDateTime = z.string().datetime({ offset: true });
export const platformSchema = z.enum(['ps3', 'ps4', 'ps5', 'psvita', 'pspc']);
export const regionSchema = z.enum(['global', 'eu', 'na', 'jp', 'asia', 'unknown']);
export const supportStateSchema = z.enum(['full', 'basic', 'catalog']);
export const dataOriginSchema = z.enum(['igdb', 'psn', 'plathunt', 'user']);
//# sourceMappingURL=primitives.js.map